<nav class="sticky top-0 z-50 bg-white h-[70px] flex items-center justify-between px-[30px] shadow-[0_4px_4px_0_#00000040]">
    <a routerLink="user/homepage" class="cursor-pointer">
        <img class="min-w-[90px] w-[105px]" src="/images/Rentzgo-logo.svg" alt="">
    </a>
    <div class="flex items-center space-x-1">
        <a routerLink="user/homepage"
            [class.!border-[#2F4157]]="activeTab === 'home'"
            [class.text-[#2F4157]]="activeTab === 'home'"
            class="border border-white text-base cursor-pointer transition-all hover:bg-[#F5F5F5] px-3 py-[6px] leading-none rounded-md">
            Home
        </a>
        <a routerLink="user/properties"
            [class.!border-[#2F4157]]="activeTab === 'property'"
            [class.text-[#2F4157]]="activeTab === 'property'"
            class="border border-white text-base cursor-pointer transition-all hover:bg-[#F5F5F5] px-3 py-[6px] leading-none rounded-md">Property</a>
        <a routerLink="user/tenants"
            [class.!border-[#2F4157]]="activeTab === 'tenant'"
            [class.text-[#2F4157]]="activeTab === 'tenant'"
            class="border border-white text-base cursor-pointer transition-all hover:bg-[#F5F5F5] px-3 py-[6px] leading-none rounded-md">My Tenant</a>
        <!-- <a routerLink="user/payments" routerLinkActive="!border-[#2F4157] text-[#2F4157]"
            [routerLinkActiveOptions]="{ exact: true }"
            class="border border-white text-base cursor-pointer transition-all hover:bg-[#F5F5F5] px-3 py-[6px] leading-none rounded-md">Payment</a> -->
        <a routerLink="user/payment-dashboard"
            [class.!border-[#2F4157]]="activeTab === 'payment'"
            [class.text-[#2F4157]]="activeTab === 'payment'"
            class="border border-white text-base cursor-pointer transition-all hover:bg-[#F5F5F5] px-3 py-[6px] leading-none rounded-md">Payment</a>
        <a (click)="openAddProperty()"
            [class.!border-[#2F4157]]="activeTab === 'add-property'"
            [class.text-[#2F4157]]="activeTab === 'add-property'"
            class="border border-white text-base cursor-pointer transition-all hover:bg-[#F5F5F5] px-3 py-[6px] leading-none rounded-md">Add
            Property</a>
        <!-- <a routerLink="user/handyman" routerLinkActive="!border-[#2F4157] text-[#2F4157]"
            [routerLinkActiveOptions]="{ exact: true }"
            class="border border-white text-base cursor-pointer transition-all hover:bg-[#F5F5F5] px-3 py-[6px] leading-none rounded-md">Handyman</a> -->
        <a routerLink="user/tenant-move-out-management"
            [class.!border-[#2F4157]]="activeTab === 'move-out'"
            [class.text-[#2F4157]]="activeTab === 'move-out'"
            class="border border-white text-base cursor-pointer transition-all hover:bg-[#F5F5F5] px-3 py-[6px] leading-none rounded-md">Move
            out</a>
        <!-- <a routerLink="user/lease-form" routerLinkActive="!border-[#2F4157] text-[#2F4157]"
            [routerLinkActiveOptions]="{ exact: true }"
            class="border border-white text-base cursor-pointer transition-all hover:bg-[#F5F5F5] px-3 py-[6px] leading-none rounded-md">Lease
            form</a> -->
    </div>
    <div class="flex items-center space-x-4 relative">
        <!-- <div class="flex items-center bg-[rgba(0,0,0,0.04)] rounded-lg px-3 gap-2">
            <img src="/images/header-search.svg" alt="">
            <input type="text" class="py-[6px] focus:outline-none placeholder:text-[#00000033] text-sm"
                placeholder="Search...">
        </div> -->
        <a routerLink="user/communication" class="cursor-pointer">
            <img class="w-[18px] min-w-[18px]" src="/images/message.svg" alt="">
            <span *ngIf="totalUnreadCount$ | async as count" class="absolute text-[8px] text-semibold text-[#FFFFFF] left-2 top-[-8px] bg-[#FF0000] w-4 h-4 rounded-full flex items-center justify-center">
                {{ count > 99 ? '99+' : count}}
            </span>
        </a>
        <a routerLink="user/notification" class="cursor-pointer">
            <img class="w-[16px] min-w-[18px]" src="/images/notification.svg" alt="">
            <span *ngIf="notificationCount" class="absolute text-[8px] text-semibold text-[#FFFFFF] left-11 top-[-8px] bg-[#FF0000] w-4 h-4 rounded-full flex items-center justify-center">{{notificationCount > 99 ? '99+' : notificationCount}}</span>
        </a>
        <a class="cursor-pointer" routerLink="user/profile">
            <img class="w-[22px] min-w-[22px] rounded-full h-[22px]" [src]="userDetails.profileImage" alt="">
        </a>
    </div>
</nav>
